import { Box, Flex } from '@mantine/core';
import {
  ProductsStore,
  ProductsStoreProvider,
  useProductsStore,
} from './ProductsStore';
import { useEffect } from 'react';
import withStoreProvider from '../../../../../util/withStoreProvider';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { Text } from '@mantine/core';
import classes from '../../LandingPage.module.css';
import { CONTENTFUL_ENGLISH_KEY } from '@web/common';
import placeholder from '../../../../../assets/placeholder.svg';
import { ProductFilterButtons } from './ProductFilterButtons';
import { ProductCarousel } from './ProductCarousel';

export const ProductsContent = observer(({ id }: { id: string }) => {
  const store = useProductsStore();
  const { t } = useTranslation('landingpage');

  const filteredProducts = store.products?.filter(
    (product) =>
      product.fields.type[CONTENTFUL_ENGLISH_KEY] === store.selectedProductType,
  );
  const hasProducts = filteredProducts && filteredProducts.length > 0;

  useEffect(() => {
    store.loadProducts();
  }, [store]);

  return (
    <Flex
      id={id}
      className={classes.baseSection}
      p="40px 20px 40px 20px"
      direction="column"
      style={{ background: '#fff' }}
      gap="16px"
      wrap="wrap"
    >
      <Flex
        direction="column"
        gap="20px"
        style={{ maxWidth: '1100px', width: '100%' }}
      >
        <Text size="50px" fw="500" lh="64px">
          {t('Products.Title')}
        </Text>
        <Text size="16px" fw="400" lh="24px" maw="800px" m="auto">
          {t('Products.Description')}
        </Text>

        <ProductFilterButtons />

        {hasProducts ? (
          <ProductCarousel
            filteredProducts={filteredProducts}
            selectedProductType={store.selectedProductType}
          />
        ) : (
          <Box p="10px" ta="center">
            <img src={placeholder} alt="product" height={100} />
            <Text size="16px" fw="400" lh="24px" p="10px" c="#4A4A48">
              {t('Products.NoProducts')}
            </Text>
          </Box>
        )}
      </Flex>
    </Flex>
  );
});

export const Products = withStoreProvider(
  new ProductsStore(),
  ProductsStoreProvider,
)(ProductsContent);
